import React from "react";
import { Card, Button } from "react-bootstrap";
import localization from "../../services/localization";
import { FaEdit, FaTrash } from "react-icons/fa";
import { icons, Shapes } from "lucide-react";

export function PromptMangmentCard({
  currentLang,
  onEdit,
  onDelete,
  item,
  icon: Icon,
  isCategory = false,
}) {
  const typeColors = {
    teaching: "bg-blue-100 text-blue-700 border-blue-300",
    administration: "bg-yellow-100 text-yellow-700 border-yellow-300",
  };

  const IconComponent =
    item.icon && icons[item.icon] ? icons[item.icon] : Shapes;

  return (
    <Card className="category-card hover:shadow-lg transition-shadow cursor-pointer mb-4 p-3 rounded-2xl border flex-1">
      <Card.Body className="flex flex-col justify-between h-full">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2 text-lg font-bold">
            <IconComponent className="title-icon h-6 w-6 mt-1 shrink-0" />
            {item.title?.[currentLang] ||
              item.title?.It ||
              item.title?.En ||
              "Unnamed Category"}
          </div>
          {isCategory && (
            <span
              className={`
              text-xs capitalize border px-2 py-0.5 rounded-full  ml-auto
              ${typeColors[item.type]}
            `}
            >
              {item.type}
            </span>
          )}
        </div>
        <div className="sub-title text-sm b-4 ms-4 text-start pb-3">
          {item.description?.[currentLang] ||
            item.description?.It ||
            item.description?.En}
        </div>
        <div className="flex gap-2 mt-auto">
          <Button
            size="sm"
            className="action-btn-outline primary flex-1 d-flex align-items-center justify-center gap-2 border transition-all rounded-pill"
            onClick={() => onEdit(item)}
          >
            <FaEdit className="h-4 w-4" />
            {localization.edit || "Edit"}
          </Button>

          <Button
            variant="outline-danger"
            size="sm"
            className="action-btn-outline danger flex-1 d-flex align-items-center justify-center gap-2 border transition-all rounded-pill"
            onClick={() => onDelete(item)}
          >
            <FaTrash className="h-4 w-4" />
            {localization.delete || "Delete"}
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
}
